import React, { Suspense, useState } from 'react';
import { lazyWithReload } from '@/lib/lazyWithReload';
import { isPartnrV2Enabled } from '@/lib/partnr/flag';
import type { PartnrChat } from '@/stores/partnrStore';

// Each Partnr loads in its own chunk after the canvas paints: the panel brings
// the AI SDK with it, and a browser only ever needs one of the two
const PartnrPanel = lazyWithReload(() => import('./PartnrPanel').then((m) => ({ default: m.PartnrPanel })));
const PartnrChatWindow = lazyWithReload(() => import('@/components/partnr/PartnrChatWindow').then((m) => ({ default: m.PartnrChatWindow })));

/**
 * Where InfiniteCanvas mounts Partnr: the Partnr 2 panel when partnr-v2 is
 * on, else today's chat window for the first active chat (single window).
 * The flag is read once per mount; it changes with a reload.
 */
export function PartnrChatMount({ activeChats }: { activeChats: PartnrChat[] }) {
  const [v2] = useState(isPartnrV2Enabled);
  if (v2) {
    return (
      <div data-export-ignore="true" data-canvas-overlay>
        <Suspense fallback={null}>
          <PartnrPanel />
        </Suspense>
      </div>
    );
  }
  if (activeChats.length === 0) return null;
  return (
    <div data-export-ignore="true" data-canvas-overlay>
      <Suspense fallback={null}>
        <PartnrChatWindow key={activeChats[0].id} chat={activeChats[0]} />
      </Suspense>
    </div>
  );
}
